package com.appcreator.client.firebase.messaging

import com.appcreator.blueprint.core.EnvFunction
import com.appcreator.blueprint.firebase.messaging.FirebaseMessagingConsts
import com.appcreator.compose.di.Container
import com.russhwolf.settings.Settings
import dev.gitlive.firebase.Firebase
import dev.gitlive.firebase.app
import kotlin.collections.set

object FirebaseMessagingInitializer {
    fun initialize() {
        appCreatorFirebaseMessagingInitialize(TopicStore(Settings()))
        Container.globalKeys[FirebaseMessagingConsts.gcpSenderId] = EnvFunction { _, _ -> getGcmSenderId() }
    }
}

expect fun getGcmSenderId(): String